import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/ui/spinner";
import { initializeTheme } from "@/utils/themeManager";
import LandingHeader from "@/components/landing/LandingHeader";
import HeroSection from "@/components/landing/HeroSection";
import VantaBackground from "@/components/landing/VantaBackground";
import WhatIsRVSection from "@/components/landing/WhatIsRVSection";
import TargetTypesSection from "@/components/landing/TargetTypesSection";
import AIFeedbackSection from "@/components/landing/AIFeedbackSection";
import SessionHistorySection from "@/components/landing/SessionHistorySection";
import PricingSection from "@/components/landing/PricingSection";
import FinalCTASection from "@/components/landing/FinalCTASection";
import LandingFooter from "@/components/landing/LandingFooter";
import SEO from "@/components/SEO";

const Landing = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    initializeTheme();
  }, []);

  useEffect(() => {
    if (user && !loading) {
      navigate("/", { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Spinner className="h-8 w-8 text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen text-foreground overflow-x-hidden">
      <SEO
        title="RemoteViz.ai — Train Your Intuition with AI Remote Viewing"
        description="Discover how RemoteViz turns remote viewing practice into a structured, AI-guided experience with locations, images, and prediction targets."
        path="/landing"
      />
      {/* Fixed Vanta.js animated background */}
      <VantaBackground />
      
      {/* Fixed hero section - stays in place */}
      <HeroSection />
      
      {/* Fixed header above everything */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <LandingHeader />
      </div>
      
      {/* Spacer to push scrollable content below the hero viewport */}
      <div className="h-screen" aria-hidden="true" />
      
      {/* Scrollable content that covers the hero */}
      <div className="relative z-20 bg-background">
        <main id="learn-more">
          <WhatIsRVSection />
          <TargetTypesSection />
          <AIFeedbackSection />
          <SessionHistorySection />
          <PricingSection />
          <FinalCTASection />
        </main>
        <LandingFooter />
      </div>
    </div>
  );
};

export default Landing;
